import { render, staticRenderFns } from "./SidePanel.vue?vue&type=template&id=147f82c6&scoped=true"
import script from "./SidePanel.vue?vue&type=script&lang=js"
export * from "./SidePanel.vue?vue&type=script&lang=js"
import style0 from "./SidePanel.vue?vue&type=style&index=0&id=147f82c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147f82c6",
  null
  
)

export default component.exports